// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shared-match-container {
  max-width: 720px;
  margin: 0 auto;
  padding: 16px 14px 40px;
  min-height: 100vh;
  color: var(--vb-text);
  box-sizing: border-box;
}

.shared-match-header {
  margin-bottom: 14px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.shared-match-header .match-date {
  margin-left: auto;
  font-size: 12px;
  font-weight: 650;
  color: var(--vb-text-muted);
  text-align: right;
}

.shared-by {
  margin-top: 6px;
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 650;
}

.live-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--vb-radius-pill);
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.live-badge::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--vb-danger);
  box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.6);
  animation: live-pulse 1.6s ease-out infinite;
}

@keyframes live-pulse {
  70% { box-shadow: 0 0 0 6px rgba(220, 38, 38, 0); }
  100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0); }
}

.back-btn,
.edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
}

.back-btn {
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
}

.back-btn:hover { background: var(--vb-surface-hover); }

.edit-btn {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border: none;
}

.edit-btn:hover { background: var(--vb-primary-hover); }

.court {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: stretch;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.06), transparent 28%),
    var(--vb-navy);
  color: #fff;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: var(--vb-shadow-lg);
  min-height: 210px;
}

.court-team {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 22px 12px 18px;
  min-width: 0;
  text-align: center;
}

.court-team.team-a {
  background: linear-gradient(180deg, rgba(225, 29, 72, 0.42), rgba(225, 29, 72, 0.05) 72%);
}

.court-team.team-b {
  background: linear-gradient(180deg, rgba(37, 99, 235, 0.45), rgba(37, 99, 235, 0.05) 72%);
}

.court-name {
  max-width: 100%;
  font-size: 13px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.25;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.court-score {
  font-family: var(--vb-font-score);
  font-size: clamp(3.4rem, 14vw, 6rem);
  font-weight: 700;
  line-height: 0.85;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.48);
}

.court-score.leading {
  color: #fff;
}

.court-mid {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 6px;
  min-width: 72px;
}

.court-clock {
  font-family: var(--vb-font-score);
  font-size: 1.55rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
}

.court-vs {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.45);
}

.timeout-indicators {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.timeout-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.45);
  background: transparent;
  box-sizing: border-box;
}

.timeout-dot.used {
  background: #fff;
  border-color: #fff;
}

.timeout-dot.available {
  background: transparent;
}

.match-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.match-meta-row span {
  padding: 6px 10px;
  border-radius: var(--vb-radius-pill);
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  font-size: 12px;
  font-weight: 700;
  color: var(--vb-text-muted);
}

.match-note-line {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.45;
  color: var(--vb-text);
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  padding: 12px 14px;
}

.match-expanders {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 14px;
}

.expander-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.expand-toggle {
  width: auto;
  text-align: left;
  min-height: 36px;
  padding: 6px 12px;
  border: 1px solid var(--vb-border);
  border-radius: 999px;
  background: var(--vb-surface);
  color: var(--vb-text);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.expand-toggle::before {
  content: '▸ ';
  color: var(--vb-text-muted);
}

.expand-toggle.open::before { content: '▾ '; }

.expand-toggle.open {
  background: var(--vb-primary-soft);
  border-color: transparent;
}

.match-scoring-order {
  margin: 0;
  padding: 12px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 14px;
}

.scoring-box {
  display: inline-block;
  border: 1px solid var(--vb-border);
  padding: 2px 6px;
  margin: 2px 1px;
  border-radius: 4px;
}

.scoring-box.winner { background-color: #d1fae5; color: #14532d; }
.scoring-box.loser { background-color: #ffe4e6; color: #881337; }

.night-mode .scoring-box { border-color: #334155; }
.night-mode .scoring-box.winner { background-color: #14532d; color: #fff; }
.night-mode .scoring-box.loser { background-color: #881337; color: #fff; }

.scoring-box.timeout-box {
  background-color: #f59e0b;
  color: #1c1917;
  font-weight: bold;
}

.scoring-box.ace-box {
  box-shadow: inset 0 0 0 1px #fbbf24;
  font-weight: 800;
}

.scoring-run {
  display: inline-block;
  padding: 1px 2px;
  margin: 1px;
  border-radius: 4px;
  position: relative;
}

.scoring-run.run-a {
  background-color: rgba(225, 29, 72, 0.1);
  border: 1px solid rgba(225, 29, 72, 0.22);
}

.scoring-run.run-b {
  background-color: rgba(37, 99, 235, 0.1);
  border: 1px solid rgba(37, 99, 235, 0.22);
}

.score-chart {
  margin: 0;
  padding: 12px 8px 4px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 14px;
}

.score-chart h4 {
  margin: 0 0 6px 8px;
  font-size: 12px;
  color: var(--vb-text-muted);
  text-align: left;
}

.loading-spinner,
.error-message {
  text-align: center;
  font-size: 15px;
  color: var(--vb-text-muted);
  padding: 72px 16px;
}

.error-message { color: var(--vb-danger); }

@media (min-width: 720px) {
  .shared-match-container { padding: 28px 20px 56px; }

  .court { min-height: 250px; border-radius: 26px; }

  .court-team { padding: 28px 20px 22px; }

  .court-name { font-size: 15px; }

  .court-mid { min-width: 96px; padding: 16px 10px; }

  .court-clock { font-size: 1.8rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/SharedMatch.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,MAAM,0CAA0C,EAAE;EAClD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,kBAAkB,mCAAmC,EAAE;;AAEvD;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;AACd;;AAEA,kBAAkB,mCAAmC,EAAE;;AAEvD;EACE,aAAa;EACb,mCAAmC;EACnC,oBAAoB;EACpB;;kBAEgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,8BAA8B,aAAa,EAAE;;AAE7C;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB,yBAAyB,EAAE,cAAc,EAAE;AACjE,qBAAqB,yBAAyB,EAAE,cAAc,EAAE;;AAEhE,2BAA2B,qBAAqB,EAAE;AAClD,kCAAkC,yBAAyB,EAAE,WAAW,EAAE;AAC1E,iCAAiC,yBAAyB,EAAE,WAAW,EAAE;;AAEzE;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,iBAAiB,uBAAuB,EAAE;;AAE1C;EACE,0BAA0B,uBAAuB,EAAE;;EAEnD,SAAS,iBAAiB,EAAE,mBAAmB,EAAE;;EAEjD,cAAc,uBAAuB,EAAE;;EAEvC,cAAc,eAAe,EAAE;;EAE/B,aAAa,eAAe,EAAE,kBAAkB,EAAE;;EAElD,eAAe,iBAAiB,EAAE;AACpC","sourcesContent":[".shared-match-container {\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 16px 14px 40px;\n  min-height: 100vh;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n.shared-match-header {\n  margin-bottom: 14px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.shared-match-header .match-date {\n  margin-left: auto;\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n  text-align: right;\n}\n\n.shared-by {\n  margin-top: 6px;\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.live-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: var(--vb-radius-pill);\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.live-badge::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--vb-danger);\n  box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.6);\n  animation: live-pulse 1.6s ease-out infinite;\n}\n\n@keyframes live-pulse {\n  70% { box-shadow: 0 0 0 6px rgba(220, 38, 38, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0); }\n}\n\n.back-btn,\n.edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 36px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.back-btn {\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n}\n\n.back-btn:hover { background: var(--vb-surface-hover); }\n\n.edit-btn {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border: none;\n}\n\n.edit-btn:hover { background: var(--vb-primary-hover); }\n\n.court {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: stretch;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.06), transparent 28%),\n    var(--vb-navy);\n  color: #fff;\n  border-radius: 22px;\n  overflow: hidden;\n  box-shadow: var(--vb-shadow-lg);\n  min-height: 210px;\n}\n\n.court-team {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 22px 12px 18px;\n  min-width: 0;\n  text-align: center;\n}\n\n.court-team.team-a {\n  background: linear-gradient(180deg, rgba(225, 29, 72, 0.42), rgba(225, 29, 72, 0.05) 72%);\n}\n\n.court-team.team-b {\n  background: linear-gradient(180deg, rgba(37, 99, 235, 0.45), rgba(37, 99, 235, 0.05) 72%);\n}\n\n.court-name {\n  max-width: 100%;\n  font-size: 13px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.25;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.court-score {\n  font-family: var(--vb-font-score);\n  font-size: clamp(3.4rem, 14vw, 6rem);\n  font-weight: 700;\n  line-height: 0.85;\n  letter-spacing: -0.03em;\n  font-variant-numeric: tabular-nums;\n  color: rgba(255, 255, 255, 0.48);\n}\n\n.court-score.leading {\n  color: #fff;\n}\n\n.court-mid {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 6px;\n  min-width: 72px;\n}\n\n.court-clock {\n  font-family: var(--vb-font-score);\n  font-size: 1.55rem;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n}\n\n.court-vs {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.timeout-indicators {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n}\n\n.timeout-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(255, 255, 255, 0.45);\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.timeout-dot.used {\n  background: #fff;\n  border-color: #fff;\n}\n\n.timeout-dot.available {\n  background: transparent;\n}\n\n.match-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.match-meta-row span {\n  padding: 6px 10px;\n  border-radius: var(--vb-radius-pill);\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--vb-text-muted);\n}\n\n.match-note-line {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--vb-text);\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n\n.match-expanders {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.expander-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.expand-toggle {\n  width: auto;\n  text-align: left;\n  min-height: 36px;\n  padding: 6px 12px;\n  border: 1px solid var(--vb-border);\n  border-radius: 999px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.expand-toggle::before {\n  content: '▸ ';\n  color: var(--vb-text-muted);\n}\n\n.expand-toggle.open::before { content: '▾ '; }\n\n.expand-toggle.open {\n  background: var(--vb-primary-soft);\n  border-color: transparent;\n}\n\n.match-scoring-order {\n  margin: 0;\n  padding: 12px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 14px;\n}\n\n.scoring-box {\n  display: inline-block;\n  border: 1px solid var(--vb-border);\n  padding: 2px 6px;\n  margin: 2px 1px;\n  border-radius: 4px;\n}\n\n.scoring-box.winner { background-color: #d1fae5; color: #14532d; }\n.scoring-box.loser { background-color: #ffe4e6; color: #881337; }\n\n.night-mode .scoring-box { border-color: #334155; }\n.night-mode .scoring-box.winner { background-color: #14532d; color: #fff; }\n.night-mode .scoring-box.loser { background-color: #881337; color: #fff; }\n\n.scoring-box.timeout-box {\n  background-color: #f59e0b;\n  color: #1c1917;\n  font-weight: bold;\n}\n\n.scoring-box.ace-box {\n  box-shadow: inset 0 0 0 1px #fbbf24;\n  font-weight: 800;\n}\n\n.scoring-run {\n  display: inline-block;\n  padding: 1px 2px;\n  margin: 1px;\n  border-radius: 4px;\n  position: relative;\n}\n\n.scoring-run.run-a {\n  background-color: rgba(225, 29, 72, 0.1);\n  border: 1px solid rgba(225, 29, 72, 0.22);\n}\n\n.scoring-run.run-b {\n  background-color: rgba(37, 99, 235, 0.1);\n  border: 1px solid rgba(37, 99, 235, 0.22);\n}\n\n.score-chart {\n  margin: 0;\n  padding: 12px 8px 4px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 14px;\n}\n\n.score-chart h4 {\n  margin: 0 0 6px 8px;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  text-align: left;\n}\n\n.loading-spinner,\n.error-message {\n  text-align: center;\n  font-size: 15px;\n  color: var(--vb-text-muted);\n  padding: 72px 16px;\n}\n\n.error-message { color: var(--vb-danger); }\n\n@media (min-width: 720px) {\n  .shared-match-container { padding: 28px 20px 56px; }\n\n  .court { min-height: 250px; border-radius: 26px; }\n\n  .court-team { padding: 28px 20px 22px; }\n\n  .court-name { font-size: 15px; }\n\n  .court-mid { min-width: 96px; padding: 16px 10px; }\n\n  .court-clock { font-size: 1.8rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
